import { LOCATION_CHANGE } from 'connected-react-router'
import {
  PREPARE_TOTP_REGISTRATION,
  PREPARE_TOTP_REGISTRATION_FAILED,
  FINISH_TOTP_REGISTRATION,
  FINISH_TOTP_REGISTRATION_SUCCEEDED,
  FINISH_TOTP_REGISTRATION_FAILED,
  PREPARE_TOTP_REGISTRATION_SUCCEEDED
} from '../constants/action.types'
import * as MFASetupSteps from '../constants/mfa.setup.steps'

const initialState = {
  step: MFASetupSteps.START_REGISTRATION,
  isFromSettings: false,
  errorCode: null,
  isProcessing: false,
  registrationData: null,
  signedRegistrationData: null
}

export default (
  state = initialState,
  { type, payload: { errorCode, registrationData, submitDataPayload } = {} }
) => {
  const newState = {
    [LOCATION_CHANGE]: initialState,
    [PREPARE_TOTP_REGISTRATION]: {
      isProcessing: true,
      disabledForm: true,
      errorCode: null
    },
    [PREPARE_TOTP_REGISTRATION_FAILED]: { errorCode },
    [PREPARE_TOTP_REGISTRATION_SUCCEEDED]: {
      errorCode: null,
      step: MFASetupSteps.REGISTER,
      registrationData
    },
    [FINISH_TOTP_REGISTRATION]: {
      isProcessing: true,
      errorCode: null,
      submitDataPayload
    },
    [FINISH_TOTP_REGISTRATION_SUCCEEDED]: {
      step: MFASetupSteps.REGISTRATION_COMPLETE
    },
    [FINISH_TOTP_REGISTRATION_FAILED]: { errorCode }
  }[type]

  return { ...state, isProcessing: false, ...newState }
}
